<template>
  <div
    class="container-fluid small_screen_effect_container"
    style="position: relative"
  >
    <div class="row">
      <div class="col-xl-12">
        <div class="page-header wallet-page-header">
          <div class="page-title">
            <i class="bx bx-left-arrow-alt" @click="goBackToWallet"></i>
            <!-- onclick="window.history.back();" -->
            <h2>Transaction History</h2>
          </div>
        </div>
        <div class="page-header-small-screen">
          <img
            src="@/assets/vectors/img/back-icon.png"
            class="arrow_bacck"
            alt=""
            @click="goBackToWallet"
          />
          <br />
          <h5>Transaction History</h5>
        </div>
      </div>
    </div>

    <div class="small_screen_effect_inner wallet_balance_page">
      <div class="row">
        <div class="col-md-12">
          <TransactionTabs />

          <div class="page-tab-content">
            <div class="relsify-tab-pane active" id="UserTransaction">
              <TransactionHistory />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/dashboard.css";
import "@/mixins";
import { mapActions } from "vuex";
import TransactionTabs from "../../components/transaction/TransactionTabs.vue";
import TransactionHistory from "@/components/transaction/userTransaction/TransactionHistory.vue";
export default {
  components: {
    TransactionHistory,
    TransactionTabs,
  },

  methods: {
    ...mapActions(["setCurrentPageName"]),
    goBackToWallet: function () {
      this.$router.push({
        name: "Wallet",
      });
    },
  },
  mounted() {
    this.closeMarketPlace();
    this.setCurrentPageName(this.$router.currentRoute._rawValue.name);
    // this.fillData();
  },
};
</script>
